import React from 'react';
import { t } from 'ttag';
import { VariablesData } from '../..';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { FlubFlub, GlibGlob } from '../../characters/Aliens';

const MissionOutro: React.FC<ISlide<VariablesData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: GlibGlob,
            text: t`I... I... I can’t believe it. You just wiped out a whole asteroid field in one mission. We are going to start running out of asteroids to blast at this rate.`,
            buttonText: t`Next`,
        },
        {
            character: FlubFlub,
            text: t`Wow! And the variables helped us keep track of how many large and small asteroids you blasted along with how much Zinon you collected. ${data.name}, you rock!`,
            buttonText: t`Next`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default MissionOutro;
